import React, { useEffect } from 'react';
import { Row, Column, Navigation, PageHeader, Text } from '@innovaccer/design-system';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import VersionDetails from './versionDetails';
import UpdateReport from './report';
import ErrorBoundary from '../../components/ErrorBoundary';
import { store } from '../../store';
import { childRoute, getGlobalVariable } from '../../utils/utils';

const navigationData = [
  {
    name: 'version_details',
    label: 'Version details',
    link: '/versionDetails'
  },
  {
    name: 'report',
    label: 'Report',
    link: '/report'
  }
];

function StandardETL(props) {
  const [active, setActive] = React.useState(navigationData[0]);
  const [pageLoading, setPageLoading] = React.useState(true);
  useEffect(() => {
    window.datashop.app.module('disableOldCss')();
  }, []);

  useEffect(() => {
    const childAppRoute = childRoute();
    if (!childAppRoute || childAppRoute == '/' || childAppRoute == '/versionDetails') {
      history.push('/standard-etl/versionDetails');
    } else {
      history.push('/standard-etl/report');
      setActive(navigationData[1]);
    }
    setPageLoading(false);
  }, [pageLoading]);

  const history = getGlobalVariable('history');

  const onClickHandler = (menu) => {
    setActive(menu);
    history.push(`/standard-etl${menu.link}`);
  };
  const navigationComponent = <Navigation menus={navigationData} onClick={onClickHandler} active={active} />;

  const renderRoutes = () => (
    <Switch>
      <Route path="/standard-etl/versionDetails" render={(props) => <VersionDetails />} />
      <Route path="/standard-etl/report" render={(props) => <UpdateReport />} />
    </Switch>
  );

  return (
    <ErrorBoundary>
      <div className="py-6 bg-secondary-lightest">
        <PageHeader title="Standard ETL" separator={false} navigation={navigationComponent} actions={[]} />
        <Provider store={store}>
          <ConnectedRouter history={history}>{renderRoutes()}</ConnectedRouter>
        </Provider>
      </div>
    </ErrorBoundary>
  );
}

export default StandardETL;
